import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import CheckboxComponent from 'components/lib/Checkbox';

import { SETTINGS_EXTRA_COLUMN_WIDTH } from './constants';
import { useSettingsContext } from './SettingsContext';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 20px 0 14px 15px;
  align-items: center;
`;

const HeaderTitle = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.5px;
`;

const LeftHeader = styled.div`
  display: flex;
  align-items: center;
`;

const ExtraColumnsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 20px;
  padding-right: 60px;
`;

const ExtraHeaderCell = styled(HeaderTitle)`
  width: ${SETTINGS_EXTRA_COLUMN_WIDTH}px;
  text-align: left;
`;

type Props = {
  extraHeaders?: string[];
};

const CommunitiesListHeader = ({ extraHeaders = [] }: Props) => {
  const { isMultipleSelection, allCommunitiesSelected, toggleAllCommunities } = useSettingsContext();

  let checkbox;
  if (isMultipleSelection) {
    checkbox = (
      <CheckboxComponent
        checked={allCommunitiesSelected}
        onChange={toggleAllCommunities}
        style={{ marginRight: '15px' }}
      />
    );
  }

  return (
    <Container>
      <LeftHeader>
        {checkbox}
        <HeaderTitle>COMMUNITY</HeaderTitle>
      </LeftHeader>
      {extraHeaders.length > 0 && (
        <ExtraColumnsHeader>
          {extraHeaders.map((header) => (
            <ExtraHeaderCell key={header}>{header}</ExtraHeaderCell>
          ))}
        </ExtraColumnsHeader>
      )}
    </Container>
  );
};

export default CommunitiesListHeader;
